import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
});

// Attach JWT on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('appToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 globally - clear token and dispatch event so AuthContext can sign out
// Do NOT use window.location.href here: it causes a full page reload which
// re-triggers onAuthStateChanged while Firebase is still signed in → infinite loop
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('appToken');
      window.dispatchEvent(new Event('auth:signout'));
    }
    if (error.response?.status === 403 && error.response?.data?.error?.includes('disabled')) {
      localStorage.removeItem('appToken');
      window.dispatchEvent(new CustomEvent('auth:disabled', { detail: error.response.data.error }));
    }
    return Promise.reject(error);
  }
);

export default api;
